import React from 'react';

import ListItem from './ListItem';
import constants from '../../utils/constants';

const Faq = () => {
  const { KabbageSimple } = constants;

  return (
    <>
      <section id="help-panel" className="panel with-shadow">
        <div className="container">
          <div id="faq-list">
            <div
              id="faq-aboutus"
              className="category-container aboutus visible collapsed-list box"
            >
              <h2 className="subtitle h1-style">Frequently Asked Questions</h2>
              <ul className="faq-list">
                <ListItem
                  question={<>What is Kabbage Funding™?</>}
                  answer="Kabbage Funding is a lending program that connects small businesses with lines of credit* of up to $250,000."
                />
                <ListItem
                  question={<>What is Invoice2go?</>}
                  answer="Invoice2go makes it effortless to create estimates, bill for work, track your numbers, get paid, and win more business – all from a handy mobile app. More than 250,000 business owners use Invoice2go to send over $2 billion in invoicing every month."
                />
                <ListItem
                  question={
                    <>
                      {'How has Invoice2go partnered with '}
                      <KabbageSimple />?
                    </>
                  }
                  answer={
                    <>
                      {'Invoice2go partnered with '}
                      <KabbageSimple />
                      {
                        ' to provide additional payment options for small business customers through Kabbage Funding.'
                      }
                    </>
                  }
                />
                <ListItem
                  question={
                    <>
                      How can I use Kabbage Funding on the Invoice2go platform?
                    </>
                  }
                  answer={
                    <>
                      {'Just log into '}
                      <KabbageSimple />
                      {
                        ' to withdraw the invoice amount from your business line of credit. Within 0-3 business days, the funds will be in your account to cover the invoice expense.'
                      }
                    </>
                  }
                />
                <ListItem
                  question={
                    <>
                      Can I only use my business line of credit to pay invoices?
                    </>
                  }
                  answer={
                    <>
                      {
                        'Covering invoices is one of the many ways you can use a '
                      }
                      <KabbageSimple />
                      {
                        ' line of credit. Once your business is approved, you can access funds for anything covering payroll and buying inventory to upgrading equipment and managing cash flow.'
                      }
                    </>
                  }
                />
              </ul>
            </div>
          </div>
        </div>
      </section>
      <a
        className="pill-button green medium view-more"
        href="https://help.kabbage.com/"
      >
        View More
      </a>
      <div className="dots" />
    </>
  );
};

export default Faq;
